import React, { useState, useEffect, useContext } from "react";
import { Formik } from "formik";
import {
  CensusAndPayroll,
  Census,
  Payroll,
  jsonToStringConverter,
  stringToFunctionConverter,
  stringToJsonConverter,
  removePassthroughFieldTrans,
} from "../../../utils";
import { Form } from "react-bootstrap";
import TargetSection from "./TargetSection";
import {
  SliderPanel,
  SourceFieldPanelComponent,
  LoaderWrapper,
} from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { DragDropContext } from "react-beautiful-dnd";
import { get, isEmpty, isEqual, isNull } from "lodash";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../../contexts";
import { onSaveMapAndTransformOutput } from "./../../../services/mapper/index";
import { fixedWidthOutputMappingSave } from "../../../services";

const FieldSetupSlider = (props) => {
  const {
    fieldOrder,
    list,
    setList,
    setShowSlideOut,
    mappedData,
    setMappedData,
    dataModel,
    fieldIndex,
    setFieldIndex,
    index,
    showSlideOut,
    isFixedWidth,
    hasHeader,
    sectionType,
    fieldArrayName,
    setFieldArrayName,
    profileId,
    mapType = 0,
    masterSourceDate,
    sourceHeaderName,
  } = props;
  const findNewFieldConst = masterSourceDate?.find(
    (_) => _.fieldName == mappedData[fieldIndex]?.fieldName
  );
  const isHeaderPassthrough =
    findNewFieldConst == undefined &&
    mappedData[fieldIndex]?.fieldName?.charAt(0) == "/" &&
    mappedData[fieldIndex]?.fieldName != "/FIELD NAME" &&
    mappedData[fieldIndex]?.isNewField == true
      ? false
      : true;
  const { state, dispatch } = useContext(manageMapperStore);
  const isEdit = !(fieldIndex == undefined || fieldIndex == null);
  const [key, setKey] = useState(isFixedWidth ? "TypeSettings" : "Header");
  const [clickToSelect, setClickToSelect] = useState(false);
  const [disabledKeys, setDisabledKeys] = useState([]);
  const [headerError, setHeaderError] = useState(false);
  const [valueError, setValueError] = useState(false);
  const [loading, setLoading] = useState(false);

  const fieldName =
    isFixedWidth &&
    `Field ${
      isEdit
        ? fieldIndex + 1
        : mappedData[index]?.fixedWidthOutputSectionFields
        ? mappedData[index]?.fixedWidthOutputSectionFields.length + 1
        : "01"
    }`;

  const sections = () => {
    switch (dataModel) {
      case 1:
        return [
          {
            name: "Payroll",
            fields: Payroll,
          },
        ];
      case 2:
        return [
          {
            name: "Census",
            fields: Census,
          },
        ];
      case 3:
        return [
          {
            name: "Payroll and Census",
            fields: CensusAndPayroll,
          },
        ];
      case 4:
        return [
          {
            name: "",
            fields: masterSourceDate,
          },
        ];
      default:
        return [
          {
            name: "Census And Payroll",
            fields: CensusAndPayroll,
          },
        ];
    }
  };
  const [section] = sections();

  useEffect(() => {
    var hasKey = mappedData[index]?.fixedWidthOutputSectionFields?.some(
      (_) => _.typeSetting === 1
    );
    var hasIndicator = mappedData[index]?.fixedWidthOutputSectionFields?.some(
      (_) => _.typeSetting === 3
    );

    if (hasKey && hasIndicator) {
      setDisabledKeys(["Key", "Indicator"]);
    } else if (hasKey) {
      setDisabledKeys(["Key"]);
    } else if (hasIndicator) {
      setDisabledKeys(["Indicator"]);
    } else {
      setDisabledKeys([]);
    }
  }, [mappedData[index]]);

  const apiCall = (data) => {
    let objectMaps = data?.map((item, index) => {
      return {
        ...item,
        mappingOutputProfileId: profileId ?? 0,
        sortOrder: index,
      };
    });
    onSaveMapAndTransformOutput(
      { id: profileId ?? 0, mappingObjectMaps: objectMaps },
      dispatch,
      state
    )
      .then((response) => {
        if (response) {
          setLoading(false);
          let res = {
            ...response,
            mappingObjectMaps: response?.mappingObjectMaps?.filter(
              (_) => !_.isDeleted
            ),
          };
          dispatch(setMapperPostResponse(res));
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          onClose();
        }
      })
      .catch((error) => {
        setLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };

  const fixedWidthApiCall = () => {
    fixedWidthOutputMappingSave({
      id: profileId ?? 0,
      fixedWidthOutputSections: mappedData,
    })
      .then((response) => {
        setLoading(false);
        let newValues = response?.fixedWidthOutputSections
          ?.filter((_) => !_.isDeleted)
          ?.map((item) => {
            return {
              ...item,
              fixedWidthOutputSectionFields: item.fixedWidthOutputSectionFields?.filter(
                (_) => !_.isDeleted
              ),
            };
          });
        let res = {
          ...response,
          fixedWidthOutputSections: newValues,
        };
        dispatch(setMapperPostResponse(res));
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        onClose();
      })
      .catch((error) => {
        setLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };
  const onFormSubmit = (values) => {
    setLoading(true);
    const headerExpression = jsonToStringConverter(values?.headerData, mapType);
    const value = jsonToStringConverter(values?.valueData, mapType);
    const hError = hasHeader
      ? mapType == 3 && values?.headerData?.value == "FIELD NAME"
        ? true
        : (hasHeader && values?.headerData.value == null) ||
          isNull(values?.headerData?.value?.path) ||
          (values?.headerData.parameterType == 2 &&
            (headerExpression.includes("null") ||
              headerExpression.includes("undefined")))
      : false;
    const vError =
      values?.valueData.value == null ||
      (values?.valueData.parameterType == 2 &&
        (value.includes("null") || value.includes("undefined")));
    setHeaderError(hError);
    setValueError(vError);
    if (hError) {
      setKey("Header");
    } else if (vError) {
      setKey("Value");
    }
    if (mapType == 3) {
      if (!hError && !vError) {
        const data = list.map((item, index) => {
          if (item?.order == fieldOrder) {
            const headerDataParam =
              values?.headerData?.parameterType == 3
                ? 1
                : values?.headerData?.parameterType;
            return {
              ...item,
              fieldName: item.isNewField ? headerExpression : item.fieldName,
              value: value,
              isConfiguration: true,
              headerDataSource: item.isNewField ? headerDataParam : 3,
              valueDataSource: values?.valueData?.parameterType,
            };
          } else {
            return { ...item };
          }
        });
        if (mappedData[mappedData?.length - 1].order == fieldOrder) {
          setMappedData([
            ...data,
            {
              order: fieldOrder + 1,
              fieldName: "/FIELD NAME",
              isNewField: true,
            },
          ]);
          setList([
            ...data,
            {
              order: fieldOrder + 1,
              fieldName: "/FIELD NAME",
              isNewField: true,
            },
          ]);
        } else {
          setList(data);
          setMappedData(data);
        }
        setShowSlideOut(false);
      }
    } else {
      if (!hError && !vError) {
        if (isFixedWidth) {
          let sectionFields = isEdit
            ? mappedData[index]?.fixedWidthOutputSectionFields.map(
                (item, i) => {
                  if (i == fieldIndex)
                    return {
                      id: item.id ?? 0,
                      typeSetting: values?.typeSetting,
                      from: values?.from,
                      to: values?.to,
                      value: value,
                      fieldName: values?.fieldName,
                    };
                  return item;
                }
              )
            : mappedData[index]?.fixedWidthOutputSectionFields
            ? [
                ...mappedData[index]?.fixedWidthOutputSectionFields,
                {
                  id: 0,
                  typeSetting: values?.typeSetting,
                  from: values?.from,
                  to: values?.to,
                  value: value,
                  fieldName: values?.fieldName,
                },
              ]
            : [
                {
                  id: 0,
                  typeSetting: values?.typeSetting,
                  from: values?.from,
                  to: values?.to,
                  value: value,
                  fieldName: values?.fieldName,
                },
              ];
          mappedData[index] = {
            ...mappedData[index],
            fixedWidthOutputSectionFields: sectionFields,
          };
          fixedWidthApiCall();
        } else {
          const data = isEdit
            ? mappedData.map((item, i) => {
                if (i == fieldIndex)
                  return {
                    id: item.id ?? 0,
                    headerExpression: headerExpression,
                    headerValue: hasHeader
                      ? stringToFunctionConverter(headerExpression, 1)
                      : values?.headerData.value,
                    value: value,
                  };
                return item;
              })
            : [
                ...mappedData,
                {
                  headerExpression: headerExpression,
                  headerValue: hasHeader
                    ? stringToFunctionConverter(headerExpression, 1)
                    : values?.headerData.value,
                  value: value,
                },
              ];
          setMappedData(data);
          apiCall(data);
        }
      }
    }
  };

  const onClose = () => {
    setShowSlideOut(false);
    setKey(isFixedWidth ? "TypeSettings" : "Header");
    setClickToSelect(false);
    setHeaderError(false);
    setValueError(false);
  };

  const handleOnDragStart = (res) => {
    // setDrag(true);
  };

  const handleOnDragUpdate = (update) => {
    // const { destination } = update;
    // if (!isNull(destination)) {
    //   setDestination(destination.droppableId);
    // }
  };

  const handleOnDragEnd = (result, values, setFieldValue) => {
    // setDrag(false);
    // setDestination(null);
    setFieldArrayName(null);
    setClickToSelect(false);
    const { draggableId } = result;

    if (result.destination == null) {
      return;
    }
    if (isEqual(result.destination, result.source)) {
      return;
    }

    let draggedData = section?.fields?.find((e, i) => {
      if (e.isCollection) {
        let data = e.childObjectMaps.find((x) => x.id == draggableId);
        return data;
      } else return e.id == draggableId;
    });
    if (draggedData?.isCollection) {
      let temp = {
        ...draggedData?.childObjectMaps.find((x) => x.id == draggableId),
        isCollection: true,
        isCollectionParent: draggedData?.isCollection,
        propertyNameParent: draggedData?.propertyName,
      };
      draggedData = temp;
    }
    let droppableId = get(result, "destination.droppableId");
    if (mapType == 3) {
      if (key == "Header" && droppableId) {
        setFieldValue(droppableId, {
          ...draggedData,
          path: draggedData?.fieldName.substring(1),
          value: draggedData?.datum ?? 1000,
          displayName: draggedData?.fieldName.substring(1),
        });
      }
      if (key == "Value" && droppableId) {
        setFieldValue(droppableId, {
          ...draggedData,
          path: draggedData?.fieldName.substring(1),
          value: draggedData?.datum ?? 1000,
          displayName: draggedData?.fieldName.substring(1),
        });
      }
    } else {
      if (key == "Header" && droppableId) {
        setFieldValue(droppableId, {
          ...draggedData,
          path: draggedData?.propertyName,
          value: draggedData?.datum ?? 1000,
        });
      }

      if (key == "Value" && droppableId) {
        setFieldValue(droppableId, {
          ...draggedData,
          path: draggedData?.propertyName,
          value: draggedData?.datum ?? 1000,
        });
      }
    }
  };
  const deleteCall = () => {
    if (mapType == 3) {
      const findListIndex = list?.findIndex((_) => _.order == fieldOrder);
      if (mappedData[index]?.isNewField) {
        mappedData.splice(index, 1);
        setMappedData(mappedData);
      } else {
        setMappedData(
          mappedData.map((item, ind) => {
            if (item.order == fieldOrder) {
              return {
                ...item,
                path: null,
                isConfiguration: false,
                value: null,
              };
            } else {
              return { ...item };
            }
          })
        );
      }
      if (!list[findListIndex]?.isNewField) {
        //   list.splice(findListIndex, 1);
        //   setList(list);
        // } else {
        setList(
          list.map((item, ind) => {
            if (item.order == fieldOrder) {
              return {
                ...item,
                path: null,
                isConfiguration: false,
                value: null,
              };
            } else {
              return { ...item };
            }
          })
        );
      }
    } else {
      if (isFixedWidth) {
        let newValues = mappedData[
          index
        ]?.fixedWidthOutputSectionFields?.filter((x, i) => i != fieldIndex);
        mappedData[index] = {
          ...mappedData[index],
          fixedWidthOutputSectionFields: newValues,
        };
        fixedWidthApiCall();
      } else {
        const data = mappedData?.filter((x, i) => i != fieldIndex);
        setMappedData(data);
        apiCall(data);
      }
      if (fieldIndex !== 0) setFieldIndex(fieldIndex - 1);
    }
    setShowSlideOut(false);
  };

  const sliderValues = () => {
    let isConst = section?.fields?.find(
      (_) => _.fieldName === mappedData[index]?.fieldName
    );
    return mapType == 3
      ? {
          headerData:
            mappedData[index]?.isNewField &&
            isNull(mappedData[index]?.fieldName)
              ? {
                  parameterType: 1,
                  value: null,
                }
              : mappedData[index]?.isNewField && !isHeaderPassthrough
              ? {
                  parameterType: 3,
                  value: sourceHeaderName,
                }
              : mappedData[index]?.isNewField &&
                (isConst != undefined ||
                  mappedData[index]?.fieldName?.charAt(0) != "/")
              ? stringToJsonConverter(
                  removePassthroughFieldTrans(mappedData[index]?.fieldName),
                  section
                )
              : {
                  parameterType: 1,
                  value: sourceHeaderName,
                },
          valueData: mappedData[index]?.value
            ? stringToJsonConverter(
                removePassthroughFieldTrans(mappedData[index]?.value),
                section
              )
            : {
                parameterType: 1,
                value: null,
              },
        }
      : isFixedWidth
      ? {
          typeSetting: get(
            mappedData[index]?.fixedWidthOutputSectionFields?.[fieldIndex],
            "typeSetting",
            2
          ),
          from: get(
            mappedData[index]?.fixedWidthOutputSectionFields?.[fieldIndex],
            "from",
            null
          ),
          to: get(
            mappedData[index]?.fixedWidthOutputSectionFields?.[fieldIndex],
            "to",
            null
          ),
          fieldName: get(
            mappedData[index]?.fixedWidthOutputSectionFields?.[fieldIndex],
            "fieldName",
            null
          ),
          valueData: mappedData[index]?.fixedWidthOutputSectionFields?.[
            fieldIndex
          ]
            ? stringToJsonConverter(
                mappedData[index]?.fixedWidthOutputSectionFields?.[fieldIndex]
                  ?.value,
                section
              )
            : {
                parameterType: [0, 2].includes(sectionType) ? 3 : 1,
                value: null,
              },
        }
      : {
          headerData: mappedData[index]?.headerExpression
            ? stringToJsonConverter(
                mappedData[index]?.headerExpression,
                section
              )
            : {
                parameterType: 1,
                value: null,
              },
          valueData: mappedData[index]?.value
            ? stringToJsonConverter(mappedData[index]?.value, section)
            : {
                parameterType: 1,
                value: null,
              },
        };
  };

  return (
    showSlideOut && (
      <LoaderWrapper isLoading={loading}>
        <Formik
          initialValues={sliderValues()}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            setValues,
            errors,
            ...rest
          }) => {
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={rest.submitCount > 0}
              >
                <SliderPanel
                  isOpen={showSlideOut}
                  size="75"
                  showCancelButton={true}
                  showSave={true}
                  showCancel={false}
                  backdropClicked={() => onClose()}
                  onSave={handleSubmit}
                  onClose={() => onClose()}
                  showHeader={true}
                  header="Field Setup"
                  headerClass="slider-title-case"
                  showSeparator={true}
                  showDeleteButton={
                    mapType == 3 ? mappedData[index]?.isConfiguration : true
                  }
                  onDelete={deleteCall}
                >
                  <DragDropContext
                    onDragStart={handleOnDragStart}
                    onDragUpdate={handleOnDragUpdate}
                    onDragEnd={(x) => handleOnDragEnd(x, values, setFieldValue)}
                  >
                    <div style={{ display: "flex" }}>
                      <SourceFieldPanelComponent
                        sections={sections()}
                        handleOnDragEnd={handleOnDragEnd}
                        fieldArrayName={fieldArrayName}
                        clickToSelect={clickToSelect}
                        showSource={[0, 2].includes(sectionType) ? false : true}
                        headerValueKey={key}
                      />
                      <TargetSection
                        isNewField={mappedData[index]?.isNewField}
                        sections={sections()}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        handleChange={handleChange}
                        mappedData={mappedData}
                        disabledKeys={disabledKeys}
                        setDisabledKeys={setDisabledKeys}
                        setValues={setValues}
                        isFixedWidth={isFixedWidth}
                        values={values}
                        index={index}
                        keyValue={key}
                        setKey={setKey}
                        hasHeader={hasHeader}
                        clickToSelect={clickToSelect}
                        setClickToSelect={setClickToSelect}
                        setFieldArrayName={setFieldArrayName}
                        fieldName={fieldName}
                        mapType={mapType}
                        showField={[0, 2].includes(sectionType) ? false : true}
                        headerError={headerError}
                        valueError={valueError}
                        fieldIndex={fieldIndex}
                      />
                    </div>
                  </DragDropContext>
                </SliderPanel>
              </Form>
            );
          }}
        </Formik>
      </LoaderWrapper>
    )
  );
};

export default FieldSetupSlider;
